/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import _ from "lodash";
import moment from "moment";
import { getApiBase } from "../../../store/apis";

// Props: idSolicitud (u otro identificador) y función para obtener datos
export const generarExcelDetalle = async (
  detalleSolicitud,
  documentacionAdministrativa,
  documentos,
  catalogos,
  citasAnteriores,
  citasProximas,
  esSolicitud
) => {
  const formatearFechaSiEsValida = (valor) => {
    const fecha = moment(valor, moment.ISO_8601, true);
    if (fecha.isValid()) {
      return fecha.format("DD/MM/YY");
    } else {
      return valor; // No era una fecha válida, lo dejamos como está
    }
  };

  // Estilo para los títulos
  const estiloTitulo = {
    font: { bold: true, color: { argb: "FF000000" } },
    alignment: { vertical: "middle", horizontal: "left" },
  };

  const workbook = new ExcelJS.Workbook();

  //INFORMACIÓN GENERAL
  const sheetInfoGeneral = workbook.addWorksheet("Información General");
  sheetInfoGeneral.getColumn("B").width = 35;
  sheetInfoGeneral.getColumn("C").width = 72;
  sheetInfoGeneral.getColumn("E").width = 35;
  sheetInfoGeneral.getColumn("F").width = 72;

  // ✅ Mapeo de datos a celdas específicas
  sheetInfoGeneral.getCell("B2").value = "INFORMACIÓN GENERAL";
  sheetInfoGeneral.getCell("B2").font = { bold: true, size: 12 };

  sheetInfoGeneral.getCell("B4").value = "Fecha de Aplicación:";
  Object.assign(sheetInfoGeneral.getCell("B4"), estiloTitulo);
  sheetInfoGeneral.getCell("C4").value = moment(detalleSolicitud.fechaAplicacion).format(
    "DD/MM/YY"
  );

  const comoSeEntero = _.find(catalogos.comoSeEntero, {
    idComoSeEntero: detalleSolicitud.idComoSeEntero,
  });
  sheetInfoGeneral.getCell("B5").value = "¿Como se enteraron del programa?:";
  Object.assign(sheetInfoGeneral.getCell("B5"), estiloTitulo);
  sheetInfoGeneral.getCell("C5").value = comoSeEntero.descripcion;

  sheetInfoGeneral.getCell("E5").value = "Especifique:";
  Object.assign(sheetInfoGeneral.getCell("E5"), estiloTitulo);
  sheetInfoGeneral.getCell("F5").value = detalleSolicitud.comoSeEnteroEspecif;

  sheetInfoGeneral.getCell("B6").value = "Persona que llena el formato:";
  Object.assign(sheetInfoGeneral.getCell("B6"), estiloTitulo);
  sheetInfoGeneral.getCell("C6").value =
    detalleSolicitud.nombreLlena +
    " " +
    detalleSolicitud.aPaternoLlena +
    " " +
    detalleSolicitud.aMaternoLlena;

  const parentesco = _.find(catalogos.parentescos, {
    idParentescoCandidato: detalleSolicitud.idParentescoCandidato,
  });
  sheetInfoGeneral.getCell("B7").value = "Parentesco con el niño(a):";
  Object.assign(sheetInfoGeneral.getCell("B7"), estiloTitulo);
  sheetInfoGeneral.getCell("C7").value = parentesco.descripcion;

  sheetInfoGeneral.getCell("E7").value = "Especifique:";
  Object.assign(sheetInfoGeneral.getCell("E7"), estiloTitulo);
  sheetInfoGeneral.getCell("F7").value = detalleSolicitud.especifiqueParentescoLlena;

  sheetInfoGeneral.getCell("B8").value = "Celular (10 dígitos):";
  Object.assign(sheetInfoGeneral.getCell("B8"), estiloTitulo);
  sheetInfoGeneral.getCell("C8").value = detalleSolicitud.celularContacto;

  sheetInfoGeneral.getCell("E8").value = "Otro teléfono (10 dígitos):";
  Object.assign(sheetInfoGeneral.getCell("E8"), estiloTitulo);
  sheetInfoGeneral.getCell("F8").value = detalleSolicitud.otroTelefonoContacto;

  sheetInfoGeneral.getCell("B9").value = "Correo Electrónico:";
  Object.assign(sheetInfoGeneral.getCell("B9"), estiloTitulo);
  sheetInfoGeneral.getCell("C9").value = detalleSolicitud.correoContacto;

  sheetInfoGeneral.getCell("B11").value = "INFORMACIÓN GENERAL DEL MENOR";
  sheetInfoGeneral.getCell("B11").font = { bold: true, size: 12 };

  sheetInfoGeneral.getCell("B13").value = "Nombre del menor:";
  Object.assign(sheetInfoGeneral.getCell("B13"), estiloTitulo);
  sheetInfoGeneral.getCell("C13").value =
    detalleSolicitud.nombreCandidato +
    " " +
    detalleSolicitud.aPaternoCandidato +
    " " +
    detalleSolicitud.aMaternoCandidato;

  sheetInfoGeneral.getCell("B14").value = "Fecha de nacimiento:";
  Object.assign(sheetInfoGeneral.getCell("B14"), estiloTitulo);
  sheetInfoGeneral.getCell("C14").value = moment(detalleSolicitud.fechaNacimiento).format(
    "DD/MM/YY"
  );

  sheetInfoGeneral.getCell("B15").value = "Nacionalidad:";
  Object.assign(sheetInfoGeneral.getCell("B15"), estiloTitulo);
  sheetInfoGeneral.getCell("C15").value = detalleSolicitud.nacionalidad;

  sheetInfoGeneral.getCell("E15").value = "Lugar de nacimiento:";
  Object.assign(sheetInfoGeneral.getCell("E15"), estiloTitulo);
  sheetInfoGeneral.getCell("F15").value = detalleSolicitud.lugarNacimiento;

  const sexo = _.find(
    [
      { id: 1, descripcion: "Masculino" },
      { id: 2, descripcion: "Femenino" },
    ],
    {
      id: detalleSolicitud.idSexo,
    }
  );
  sheetInfoGeneral.getCell("B16").value = "Sexo:";
  Object.assign(sheetInfoGeneral.getCell("B16"), estiloTitulo);
  sheetInfoGeneral.getCell("C16").value = sexo.descripcion;

  sheetInfoGeneral.getCell("B17").value = "Nombre de la madre:";
  Object.assign(sheetInfoGeneral.getCell("B17"), estiloTitulo);
  sheetInfoGeneral.getCell("C17").value =
    detalleSolicitud.nombreMadre +
    " " +
    detalleSolicitud.aPaternoMadre +
    " " +
    detalleSolicitud.aMaternoMadre;

  sheetInfoGeneral.getCell("E17").value = "Ocupación de la madre:";
  Object.assign(sheetInfoGeneral.getCell("E17"), estiloTitulo);
  sheetInfoGeneral.getCell("F17").value = detalleSolicitud.ocupacionMadre;

  sheetInfoGeneral.getCell("B18").value = "Nombre del padre:";
  Object.assign(sheetInfoGeneral.getCell("B18"), estiloTitulo);
  sheetInfoGeneral.getCell("C18").value =
    detalleSolicitud.nombrePadre +
    " " +
    detalleSolicitud.aPaternoPadre +
    " " +
    detalleSolicitud.aMaternoPadre;

  sheetInfoGeneral.getCell("E18").value = "Ocupación del padre:";
  Object.assign(sheetInfoGeneral.getCell("E18"), estiloTitulo);
  sheetInfoGeneral.getCell("F18").value = detalleSolicitud.ocupacionPadre;

  sheetInfoGeneral.getCell("B19").value = "Dirección del niño(a):";
  Object.assign(sheetInfoGeneral.getCell("B19"), estiloTitulo);
  sheetInfoGeneral.getCell("C19").value = detalleSolicitud.direccionCandidato;

  const entidad = _.find(catalogos.entidades, {
    idEntidad: detalleSolicitud.idEntidad,
  });
  sheetInfoGeneral.getCell("B20").value = "Entidad federativa:";
  Object.assign(sheetInfoGeneral.getCell("B20"), estiloTitulo);
  sheetInfoGeneral.getCell("C20").value = entidad.entidad;

  const municipio = _.find(catalogos.municipios, {
    idMunicipio: detalleSolicitud.idMunicipio,
  });
  sheetInfoGeneral.getCell("E20").value = "Municipio:";
  Object.assign(sheetInfoGeneral.getCell("E20"), estiloTitulo);
  sheetInfoGeneral.getCell("F20").value = municipio.municipio;

  sheetInfoGeneral.getCell("B21").value = "Pediatra / Médico 1er Contacto:";
  Object.assign(sheetInfoGeneral.getCell("B21"), estiloTitulo);
  sheetInfoGeneral.getCell("C21").value = detalleSolicitud.nombrePediatra;

  sheetInfoGeneral.getCell("E21").value = "Celular:";
  Object.assign(sheetInfoGeneral.getCell("E21"), estiloTitulo);
  sheetInfoGeneral.getCell("F21").value = detalleSolicitud.celularPediatra;

  sheetInfoGeneral.getCell("B22").value = "Dirección del pediatra:";
  Object.assign(sheetInfoGeneral.getCell("B22"), estiloTitulo);
  sheetInfoGeneral.getCell("C22").value = detalleSolicitud.direccionPediatra;

  sheetInfoGeneral.getCell("B23").value = "Cuidador primario del niño(a):";
  Object.assign(sheetInfoGeneral.getCell("B23"), estiloTitulo);
  sheetInfoGeneral.getCell("C23").value =
    detalleSolicitud.nombreCuidador +
    " " +
    detalleSolicitud.aPaternoCuidador +
    " " +
    detalleSolicitud.aMaternoCuidador;

  const parentescoCuidador = _.find(catalogos.parentescos, {
    idParentescoCandidato: detalleSolicitud.idParentescoCuidador,
  });
  sheetInfoGeneral.getCell("B24").value = "Parentesco con el niño(a):";
  Object.assign(sheetInfoGeneral.getCell("B24"), estiloTitulo);
  sheetInfoGeneral.getCell("C24").value = parentescoCuidador.descripcion;

  sheetInfoGeneral.getCell("E24").value = "Ocupación del padre:";
  Object.assign(sheetInfoGeneral.getCell("E24"), estiloTitulo);
  sheetInfoGeneral.getCell("F24").value = detalleSolicitud.especifiqueParentescoCuidador;

  const servicioMedico = _.find(catalogos.serviciosMedicos, {
    idServicioMedico: detalleSolicitud.idServicioMedico,
  });
  sheetInfoGeneral.getCell("B25").value = "Cuenta con servicio médico:";
  Object.assign(sheetInfoGeneral.getCell("B25"), estiloTitulo);
  sheetInfoGeneral.getCell("C25").value = servicioMedico.descripcion;

  sheetInfoGeneral.getCell("E25").value = "Otro:";
  Object.assign(sheetInfoGeneral.getCell("E25"), estiloTitulo);
  sheetInfoGeneral.getCell("F25").value = detalleSolicitud.otroServicioMedico;

  sheetInfoGeneral.getCell("B26").value = "Información adicional:";
  Object.assign(sheetInfoGeneral.getCell("B26"), estiloTitulo);
  sheetInfoGeneral.getCell("B26").alignment = {
    vertical: "top", // o "middle" o "bottom"
  };
  sheetInfoGeneral.getCell("C26").value = detalleSolicitud.infoAdicional;
  sheetInfoGeneral.getCell("C26").alignment = {
    wrapText: true,
    vertical: "top", // o "middle" o "bottom"
  };

  //ANTECEDENTES
  const sheetAntecedentes = workbook.addWorksheet("Antecedentes");
  sheetAntecedentes.getColumn("B").width = 60;
  sheetAntecedentes.getColumn("C").width = 80;
  sheetAntecedentes.getColumn("E").width = 60;
  sheetAntecedentes.getColumn("F").width = 80;

  // ✅ Mapeo de datos a celdas específicas
  sheetAntecedentes.getCell("B2").value = "ANTECEDENTES HEREDOFAMILIARES";
  sheetAntecedentes.getCell("B2").font = { bold: true, size: 12 };

  sheetAntecedentes.getCell("B4").value = "Enfermedades de la madre:";
  Object.assign(sheetAntecedentes.getCell("B4"), estiloTitulo);

  sheetAntecedentes.getCell("B5").value = "Auditivas:";
  Object.assign(sheetAntecedentes.getCell("B5"), estiloTitulo);
  sheetAntecedentes.getCell("C5").value = detalleSolicitud.probAudicionMadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B6").value = "Neoplásicas (Cáncer):";
  Object.assign(sheetAntecedentes.getCell("B6"), estiloTitulo);
  sheetAntecedentes.getCell("C6").value = detalleSolicitud.enfNeoplasicasMadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B7").value = "Metabólicas:";
  Object.assign(sheetAntecedentes.getCell("B7"), estiloTitulo);
  sheetAntecedentes.getCell("C7").value = detalleSolicitud.enfMetabolicasMadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B8").value = "Renales:";
  Object.assign(sheetAntecedentes.getCell("B8"), estiloTitulo);
  sheetAntecedentes.getCell("C8").value = detalleSolicitud.probRenalesMadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B9").value = "Cardiovasculares:";
  Object.assign(sheetAntecedentes.getCell("B9"), estiloTitulo);
  sheetAntecedentes.getCell("C9").value = detalleSolicitud.enfCardioMadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B10").value = "Psiquiátricas:";
  Object.assign(sheetAntecedentes.getCell("B10"), estiloTitulo);
  sheetAntecedentes.getCell("C10").value = detalleSolicitud.enfPsiqMadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B11").value = "Ninguna:";
  Object.assign(sheetAntecedentes.getCell("B11"), estiloTitulo);
  sheetAntecedentes.getCell("C11").value = detalleSolicitud.enfNingunaMadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B12").value = "Otras:";
  Object.assign(sheetAntecedentes.getCell("B12"), estiloTitulo);
  sheetAntecedentes.getCell("C12").value = detalleSolicitud.otrasHeredoMadre;

  sheetAntecedentes.getCell("B14").value = "Enfermedades del padre:";
  Object.assign(sheetAntecedentes.getCell("B14"), estiloTitulo);

  sheetAntecedentes.getCell("B15").value = "Auditivas:";
  Object.assign(sheetAntecedentes.getCell("B15"), estiloTitulo);
  sheetAntecedentes.getCell("C15").value = detalleSolicitud.probAudicionPadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B16").value = "Neoplásicas (Cáncer):";
  Object.assign(sheetAntecedentes.getCell("B16"), estiloTitulo);
  sheetAntecedentes.getCell("C16").value = detalleSolicitud.enfNeoplasicasPadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B17").value = "Metabólicas:";
  Object.assign(sheetAntecedentes.getCell("B17"), estiloTitulo);
  sheetAntecedentes.getCell("C17").value = detalleSolicitud.enfMetabolicasPadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B18").value = "Renales:";
  Object.assign(sheetAntecedentes.getCell("B18"), estiloTitulo);
  sheetAntecedentes.getCell("C18").value = detalleSolicitud.probRenalesPadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B19").value = "Cardiovasculares:";
  Object.assign(sheetAntecedentes.getCell("B19"), estiloTitulo);
  sheetAntecedentes.getCell("C19").value = detalleSolicitud.enfCardioPadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B20").value = "Psiquiátricas:";
  Object.assign(sheetAntecedentes.getCell("B20"), estiloTitulo);
  sheetAntecedentes.getCell("C20").value = detalleSolicitud.enfPsiqPadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B21").value = "Ninguna:";
  Object.assign(sheetAntecedentes.getCell("B21"), estiloTitulo);
  sheetAntecedentes.getCell("C21").value = detalleSolicitud.enfNingunaPadre == 1 ? "X" : "";

  sheetAntecedentes.getCell("B22").value = "Otras:";
  Object.assign(sheetAntecedentes.getCell("B22"), estiloTitulo);
  sheetAntecedentes.getCell("C22").value = detalleSolicitud.otrasHeredoPadre;

  sheetAntecedentes.getCell("B24").value = "Enfermedades de hermanos:";
  Object.assign(sheetAntecedentes.getCell("B24"), estiloTitulo);

  sheetAntecedentes.getCell("B25").value = "Auditivas:";
  Object.assign(sheetAntecedentes.getCell("B25"), estiloTitulo);
  sheetAntecedentes.getCell("C25").value = detalleSolicitud.probAudicionHermanos == 1 ? "X" : "";

  sheetAntecedentes.getCell("B26").value = "Neoplásicas (Cáncer):";
  Object.assign(sheetAntecedentes.getCell("B26"), estiloTitulo);
  sheetAntecedentes.getCell("C26").value = detalleSolicitud.enfNeoplasicasHermanos == 1 ? "X" : "";

  sheetAntecedentes.getCell("B27").value = "Metabólicas:";
  Object.assign(sheetAntecedentes.getCell("B27"), estiloTitulo);
  sheetAntecedentes.getCell("C27").value = detalleSolicitud.enfMetabolicasHermanos == 1 ? "X" : "";

  sheetAntecedentes.getCell("B28").value = "Renales:";
  Object.assign(sheetAntecedentes.getCell("B28"), estiloTitulo);
  sheetAntecedentes.getCell("C28").value = detalleSolicitud.probRenalesHermanos == 1 ? "X" : "";

  sheetAntecedentes.getCell("B29").value = "Cardiovasculares:";
  Object.assign(sheetAntecedentes.getCell("B29"), estiloTitulo);
  sheetAntecedentes.getCell("C29").value = detalleSolicitud.enfCardioHermanos == 1 ? "X" : "";

  sheetAntecedentes.getCell("B30").value = "Psiquiátricas:";
  Object.assign(sheetAntecedentes.getCell("B30"), estiloTitulo);
  sheetAntecedentes.getCell("C30").value = detalleSolicitud.enfPsiqHermanos == 1 ? "X" : "";

  sheetAntecedentes.getCell("B31").value = "Ninguna:";
  Object.assign(sheetAntecedentes.getCell("B31"), estiloTitulo);
  sheetAntecedentes.getCell("C31").value = detalleSolicitud.enfNingunaHermanos == 1 ? "X" : "";

  sheetAntecedentes.getCell("B32").value = "Otras:";
  Object.assign(sheetAntecedentes.getCell("B32"), estiloTitulo);
  sheetAntecedentes.getCell("C32").value = detalleSolicitud.otrasHeredoHermanos;

  sheetAntecedentes.getCell("B34").value = "Enfermedades de otros familiares:";
  Object.assign(sheetAntecedentes.getCell("B34"), estiloTitulo);

  sheetAntecedentes.getCell("B35").value = "¿Qué familiar?:";
  Object.assign(sheetAntecedentes.getCell("B35"), estiloTitulo);
  sheetAntecedentes.getCell("C35").value = detalleSolicitud.nombreFamiliarHeredo;

  sheetAntecedentes.getCell("B36").value = "Auditivas:";
  Object.assign(sheetAntecedentes.getCell("B36"), estiloTitulo);
  sheetAntecedentes.getCell("C36").value = detalleSolicitud.probAudicionFamiliar == 1 ? "X" : "";

  sheetAntecedentes.getCell("B37").value = "Neoplásicas (Cáncer):";
  Object.assign(sheetAntecedentes.getCell("B37"), estiloTitulo);
  sheetAntecedentes.getCell("C37").value = detalleSolicitud.enfNeoplasicasFamiliar == 1 ? "X" : "";

  sheetAntecedentes.getCell("B38").value = "Metabólicas:";
  Object.assign(sheetAntecedentes.getCell("B38"), estiloTitulo);
  sheetAntecedentes.getCell("C38").value = detalleSolicitud.enfMetabolicasFamiliar == 1 ? "X" : "";

  sheetAntecedentes.getCell("B39").value = "Renales:";
  Object.assign(sheetAntecedentes.getCell("B39"), estiloTitulo);
  sheetAntecedentes.getCell("C39").value = detalleSolicitud.probRenalesFamiliar == 1 ? "X" : "";

  sheetAntecedentes.getCell("B40").value = "Cardiovasculares:";
  Object.assign(sheetAntecedentes.getCell("B40"), estiloTitulo);
  sheetAntecedentes.getCell("C40").value = detalleSolicitud.enfCardioFamiliar == 1 ? "X" : "";

  sheetAntecedentes.getCell("B41").value = "Psiquiátricas:";
  Object.assign(sheetAntecedentes.getCell("B41"), estiloTitulo);
  sheetAntecedentes.getCell("C41").value = detalleSolicitud.enfPsiqFamiliar == 1 ? "X" : "";

  sheetAntecedentes.getCell("B42").value = "Otras:";
  Object.assign(sheetAntecedentes.getCell("B42"), estiloTitulo);
  sheetAntecedentes.getCell("C42").value = detalleSolicitud.otrasHeredoFamiliar;

  sheetAntecedentes.getCell("B44").value = "ANTECEDENTES PERSONALES NO PATOLÓGICOS DEL MENOR";
  sheetAntecedentes.getCell("B44").font = { bold: true, size: 12 };

  sheetAntecedentes.getCell("B46").value = "Dieta y alimentación:";
  Object.assign(sheetAntecedentes.getCell("B46"), estiloTitulo);
  sheetAntecedentes.getCell("B46").alignment = {
    vertical: "top",
  };
  sheetAntecedentes.getCell("C46").value = detalleSolicitud.dietaAlimentacion;
  sheetAntecedentes.getCell("C46").alignment = {
    wrapText: true,
    vertical: "top",
  };

  sheetAntecedentes.getCell("E46").value = "¿Cuenta con el esquema completo de vacunación?:";
  Object.assign(sheetAntecedentes.getCell("E46"), estiloTitulo);
  sheetAntecedentes.getCell("F46").value = detalleSolicitud.vacunacionCompleta == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B47").value = "¿Fuman en casa?:";
  Object.assign(sheetAntecedentes.getCell("B47"), estiloTitulo);
  sheetAntecedentes.getCell("C47").value = detalleSolicitud.fumanEnCasa == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E47").value = "¿Quién?:";
  Object.assign(sheetAntecedentes.getCell("E47"), estiloTitulo);
  sheetAntecedentes.getCell("F47").value = detalleSolicitud.quienFuma;

  const tipoSangre = _.find(
    [
      { label: "No lo sé", value: 0 },
      { label: "A", value: 1 },
      { label: "B", value: 2 },
      { label: "AB", value: 3 },
      { label: "O", value: 4 },
    ],
    {
      value: detalleSolicitud.idTipoSangre,
    }
  );
  const tipoSangreRh = _.find(
    [
      { label: "No lo sé", value: 0 },
      { label: "+ Positivo", value: 1 },
      { label: "- Negativo", value: 2 },
    ],
    {
      value: detalleSolicitud.idTipoSangreRh,
    }
  );
  sheetAntecedentes.getCell("B48").value = "Tipo de sangre:";
  Object.assign(sheetAntecedentes.getCell("B48"), estiloTitulo);
  sheetAntecedentes.getCell("C48").value = tipoSangre.label + " " + tipoSangreRh.label;

  sheetAntecedentes.getCell("E48").value = "¿Asiste a guardería?:";
  Object.assign(sheetAntecedentes.getCell("E48"), estiloTitulo);
  sheetAntecedentes.getCell("F48").value = detalleSolicitud.asisteGuarderia == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B49").value = "Alergias:";
  Object.assign(sheetAntecedentes.getCell("B49"), estiloTitulo);
  sheetAntecedentes.getCell("C49").value = detalleSolicitud.alergiasCandidato;

  sheetAntecedentes.getCell("B51").value = "ANTECEDENTES PRENATALES";
  sheetAntecedentes.getCell("B51").font = { bold: true, size: 12 };

  sheetAntecedentes.getCell("B53").value = "Edad gestacional (semanas):";
  Object.assign(sheetAntecedentes.getCell("B53"), estiloTitulo);
  sheetAntecedentes.getCell("C53").value = detalleSolicitud.edadGestacional;

  const tipoParto = _.find(catalogos.tiposParto, {
    idTipoParto: detalleSolicitud.idTipoParto,
  });
  sheetAntecedentes.getCell("E53").value = "Producto de:";
  Object.assign(sheetAntecedentes.getCell("E53"), estiloTitulo);
  sheetAntecedentes.getCell("F53").value = tipoParto?.tipoParto ? tipoParto.tipoParto : "";

  sheetAntecedentes.getCell("B54").value = "Peso al nacer (kg):";
  Object.assign(sheetAntecedentes.getCell("B54"), estiloTitulo);
  sheetAntecedentes.getCell("C54").value = detalleSolicitud.pesoNacimiento;

  sheetAntecedentes.getCell("E54").value = "Talla (cm):";
  Object.assign(sheetAntecedentes.getCell("E54"), estiloTitulo);
  sheetAntecedentes.getCell("F54").value = detalleSolicitud.tallaNacimiento;

  const apgar = [
    {
      label: "N/A",
      value: 0,
    },
    {
      label: "1",
      value: 1,
    },
    {
      label: "2",
      value: 2,
    },
    {
      label: "3",
      value: 3,
    },
    {
      label: "4",
      value: 4,
    },
    {
      label: "5",
      value: 5,
    },
    {
      label: "6",
      value: 6,
    },
    {
      label: "7",
      value: 7,
    },
    {
      label: "8",
      value: 8,
    },
    {
      label: "9",
      value: 9,
    },
    {
      label: "10",
      value: 10,
    },
  ];

  const apgar1 = _.find(apgar, {
    value: detalleSolicitud.apgaR1,
  });
  const apgar2 = _.find(apgar, {
    value: detalleSolicitud.apgaR2,
  });
  sheetAntecedentes.getCell("B55").value = "APGAR:";
  Object.assign(sheetAntecedentes.getCell("B55"), estiloTitulo);
  sheetAntecedentes.getCell("C55").value = apgar1.label + " " + apgar2.label;

  sheetAntecedentes.getCell("B56").value = "¿Ha estado en terapia intensiva?:";
  Object.assign(sheetAntecedentes.getCell("B56"), estiloTitulo);
  sheetAntecedentes.getCell("C56").value = detalleSolicitud.terapiaIntensiva == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E56").value = "Motivo/Duración de la estancia (días):";
  Object.assign(sheetAntecedentes.getCell("E56"), estiloTitulo);
  sheetAntecedentes.getCell("F56").value = detalleSolicitud.motivoTerapiaIntensiva;

  sheetAntecedentes.getCell("B57").value = "¿Dado de alta con la madre?:";
  Object.assign(sheetAntecedentes.getCell("B57"), estiloTitulo);
  sheetAntecedentes.getCell("C57").value = detalleSolicitud.dadoAltaConMadre == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E57").value = "¿Padeció ictericia?:";
  Object.assign(sheetAntecedentes.getCell("E57"), estiloTitulo);
  sheetAntecedentes.getCell("F57").value = detalleSolicitud.padecioIctericia == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B58").value = "¿Alguna infección importante durante el embarazo?:";
  Object.assign(sheetAntecedentes.getCell("B58"), estiloTitulo);
  sheetAntecedentes.getCell("C58").value = detalleSolicitud.infeccionEmbarazo == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E58").value = "Especifique:";
  Object.assign(sheetAntecedentes.getCell("E58"), estiloTitulo);
  sheetAntecedentes.getCell("F58").value = detalleSolicitud.especifiqueInfeccion;

  sheetAntecedentes.getCell("B59").value =
    "Resultado Estudio Torch: (Realizado a la madre durante el primer trimestre del embarazo):";
  Object.assign(sheetAntecedentes.getCell("B59"), estiloTitulo);
  sheetAntecedentes.getCell("B59").alignment = {
    wrapText: true,
    vertical: "top",
  };
  sheetAntecedentes.getCell("C59").value = detalleSolicitud.resEstudioTorch;
  sheetAntecedentes.getCell("C59").alignment = {
    vertical: "top",
  };

  //Antecedentes perinatales
  sheetAntecedentes.getCell("B60").value = "¿Ha tenido meningitis?:";
  Object.assign(sheetAntecedentes.getCell("B60"), estiloTitulo);
  sheetAntecedentes.getCell("C60").value = detalleSolicitud.tuvoMeningitis == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E60").value = "¿Requirió ventilación mecánica?:";
  Object.assign(sheetAntecedentes.getCell("E60"), estiloTitulo);
  sheetAntecedentes.getCell("F60").value = detalleSolicitud.ventilacionMecanica == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B61").value = "¿Tiene alguna malformación?:";
  Object.assign(sheetAntecedentes.getCell("B61"), estiloTitulo);
  sheetAntecedentes.getCell("C61").value = detalleSolicitud.malformacion == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E61").value = "¿Cuál?:";
  Object.assign(sheetAntecedentes.getCell("E61"), estiloTitulo);
  sheetAntecedentes.getCell("F61").value = detalleSolicitud.cualMalformacion;

  sheetAntecedentes.getCell("B62").value = "¿Ha tenido crisis convulsivas?:";
  Object.assign(sheetAntecedentes.getCell("B62"), estiloTitulo);
  sheetAntecedentes.getCell("C62").value = detalleSolicitud.crisisConvulsivas == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B63").value = "¿Ha tomado algún medicamento?:";
  Object.assign(sheetAntecedentes.getCell("B63"), estiloTitulo);
  sheetAntecedentes.getCell("C63").value = detalleSolicitud.tomadoMedicamentos == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E63").value = "¿Cuáles?:";
  Object.assign(sheetAntecedentes.getCell("E63"), estiloTitulo);
  sheetAntecedentes.getCell("F63").value = detalleSolicitud.cualesMedicamentos;

  sheetAntecedentes.getCell("B64").value = "¿Ha tenido caídas o golpes en cabeza?:";
  Object.assign(sheetAntecedentes.getCell("B64"), estiloTitulo);
  sheetAntecedentes.getCell("C64").value = detalleSolicitud.golpesCabeza == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E64").value = "Especifique:";
  Object.assign(sheetAntecedentes.getCell("E64"), estiloTitulo);
  sheetAntecedentes.getCell("F64").value = detalleSolicitud.especifiqueGolpes;

  sheetAntecedentes.getCell("B65").value = "¿Se le hizo el Tamiz neonatal metabólico?:";
  Object.assign(sheetAntecedentes.getCell("B65"), estiloTitulo);
  sheetAntecedentes.getCell("C65").value = detalleSolicitud.tamizNeoMetabolico == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E65").value = "Resultado:";
  Object.assign(sheetAntecedentes.getCell("E65"), estiloTitulo);
  sheetAntecedentes.getCell("F65").value = detalleSolicitud.resTamizNeoMetabolico;

  sheetAntecedentes.getCell("B66").value = "¿Se le hizo el Tamiz neonatal auditivo?:";
  Object.assign(sheetAntecedentes.getCell("B66"), estiloTitulo);
  sheetAntecedentes.getCell("C66").value = detalleSolicitud.tamizNeoAuditivo == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E66").value = "Resultado:";
  Object.assign(sheetAntecedentes.getCell("E66"), estiloTitulo);
  sheetAntecedentes.getCell("F66").value = detalleSolicitud.resTamizNeoAuditivo;

  sheetAntecedentes.getCell("B67").value = "¿Se le hizo el Tamiz neonatal visual?:";
  Object.assign(sheetAntecedentes.getCell("B67"), estiloTitulo);
  sheetAntecedentes.getCell("C67").value = detalleSolicitud.tamizNeoVisual == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E67").value = "Resultado:";
  Object.assign(sheetAntecedentes.getCell("E67"), estiloTitulo);
  sheetAntecedentes.getCell("F67").value = detalleSolicitud.resTamizNeoVisual;

  sheetAntecedentes.getCell("B68").value = "¿Se le hizo el Tamiz neonatal cardiaco?:";
  Object.assign(sheetAntecedentes.getCell("B68"), estiloTitulo);
  sheetAntecedentes.getCell("C68").value = detalleSolicitud.tamizNeoCardiaco == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E68").value = "Resultado:";
  Object.assign(sheetAntecedentes.getCell("E68"), estiloTitulo);
  sheetAntecedentes.getCell("F68").value = detalleSolicitud.resTamizNeoCardiaco;

  sheetAntecedentes.getCell("B69").value = "Medicamentos que toma actualmente:";
  Object.assign(sheetAntecedentes.getCell("B69"), estiloTitulo);
  sheetAntecedentes.getCell("C69").value = detalleSolicitud.medicamentosActuales;

  sheetAntecedentes.getCell("B70").value = "¿Ha tenido infecciones en el oído?:";
  Object.assign(sheetAntecedentes.getCell("B70"), estiloTitulo);
  sheetAntecedentes.getCell("C70").value = detalleSolicitud.infeccionesOido == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E70").value = "Especifique:";
  Object.assign(sheetAntecedentes.getCell("E70"), estiloTitulo);
  sheetAntecedentes.getCell("F70").value = detalleSolicitud.especifiqueInfeccionesOido;

  sheetAntecedentes.getCell("B71").value =
    "¿Infecciones en garganta recurrentes? (más de 6 por año):";
  Object.assign(sheetAntecedentes.getCell("B71"), estiloTitulo);
  sheetAntecedentes.getCell("B71").alignment = {
    wrapText: true,
    vertical: "top",
  };
  sheetAntecedentes.getCell("C71").value = detalleSolicitud.infeccionesGarganta == 1 ? "Sí" : "No";
  sheetAntecedentes.getCell("C71").alignment = {
    vertical: "top",
  };

  sheetAntecedentes.getCell("E71").value = "¿Ronca?:";
  Object.assign(sheetAntecedentes.getCell("E71"), estiloTitulo);
  sheetAntecedentes.getCell("E71").alignment = {
    vertical: "top",
  };
  sheetAntecedentes.getCell("F71").value = detalleSolicitud.ronca == 1 ? "Sí" : "No";
  sheetAntecedentes.getCell("F71").alignment = {
    vertical: "top",
  };

  sheetAntecedentes.getCell("B72").value = "¿Ha tenido cirugías?:";
  Object.assign(sheetAntecedentes.getCell("B72"), estiloTitulo);
  sheetAntecedentes.getCell("C72").value = detalleSolicitud.tieneCirugias == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E72").value = "Especifique:";
  Object.assign(sheetAntecedentes.getCell("E72"), estiloTitulo);
  sheetAntecedentes.getCell("F72").value = detalleSolicitud.especifiqueCirugias;

  sheetAntecedentes.getCell("B73").value = "¿Problemas de Alimentación?:";
  Object.assign(sheetAntecedentes.getCell("B73"), estiloTitulo);
  sheetAntecedentes.getCell("C73").value = detalleSolicitud.problemaAlimentacion == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E73").value = "Especifique:";
  Object.assign(sheetAntecedentes.getCell("E73"), estiloTitulo);
  sheetAntecedentes.getCell("F73").value = detalleSolicitud.especifiqueProbAlimenta;

  sheetAntecedentes.getCell("B74").value = "¿Ha estado hospitalizado?:";
  Object.assign(sheetAntecedentes.getCell("B74"), estiloTitulo);
  sheetAntecedentes.getCell("C74").value = detalleSolicitud.hospitalizado == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B75").value =
    "¿Tuvo o sospecha de infección de CMV (citomegalovirus)?:";
  Object.assign(sheetAntecedentes.getCell("B75"), estiloTitulo);
  sheetInfoGeneral.getCell("B75").alignment = {
    wrapText: true,
    vertical: "top",
  };
  sheetAntecedentes.getCell("C75").value = detalleSolicitud.infeccionCMV == 1 ? "Sí" : "No";
  sheetInfoGeneral.getCell("C75").alignment = {
    vertical: "top",
  };

  sheetAntecedentes.getCell("E75").value = "Especifique:";
  Object.assign(sheetAntecedentes.getCell("E75"), estiloTitulo);
  sheetAntecedentes.getCell("F75").value = detalleSolicitud.especifiqueInfeccionCMV;

  sheetAntecedentes.getCell("B77").value = "EVALUACIÓN AUDITIVA";
  sheetAntecedentes.getCell("B77").font = { bold: true, size: 12 };

  sheetAntecedentes.getCell("B78").value = "Idioma de la madre:";
  Object.assign(sheetAntecedentes.getCell("B78"), estiloTitulo);
  sheetAntecedentes.getCell("C78").value = detalleSolicitud.idiomaMadre;

  sheetAntecedentes.getCell("E78").value = "Idioma del padre:";
  Object.assign(sheetAntecedentes.getCell("E78"), estiloTitulo);
  sheetAntecedentes.getCell("F78").value = detalleSolicitud.idiomaPadre;

  sheetAntecedentes.getCell("B79").value = "Idioma en casa:";
  Object.assign(sheetAntecedentes.getCell("B79"), estiloTitulo);
  sheetAntecedentes.getCell("C79").value = detalleSolicitud.idiomaEnCasa;

  sheetAntecedentes.getCell("B80").value = "¿Ha sido evaluado por un Audiólogo?:";
  Object.assign(sheetAntecedentes.getCell("B80"), estiloTitulo);
  sheetAntecedentes.getCell("C80").value = detalleSolicitud.evaluadoAudiologia == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E80").value = "Nombre Audiólogo:";
  Object.assign(sheetAntecedentes.getCell("E80"), estiloTitulo);
  sheetAntecedentes.getCell("F80").value = detalleSolicitud.audiologoEvalua;

  sheetAntecedentes.getCell("B81").value = "¿Ha sido evaluado por un Otorrino?:";
  Object.assign(sheetAntecedentes.getCell("B81"), estiloTitulo);
  sheetAntecedentes.getCell("C81").value = detalleSolicitud.evaluadoOtorrino == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E81").value = "Nombre Audiólogo:";
  Object.assign(sheetAntecedentes.getCell("E81"), estiloTitulo);
  sheetAntecedentes.getCell("F81").value = detalleSolicitud.otorrinoEvalua;

  sheetAntecedentes.getCell("B82").value = "¿Ha sido evaluado en Terapia de Lenguaje?:";
  Object.assign(sheetAntecedentes.getCell("B82"), estiloTitulo);
  sheetAntecedentes.getCell("C82").value =
    detalleSolicitud.evaluadoTerapiaLenguaje == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E82").value = "Nombre Terapeuta:";
  Object.assign(sheetAntecedentes.getCell("E82"), estiloTitulo);
  sheetAntecedentes.getCell("F82").value = detalleSolicitud.terapeutaEvalua;

  sheetAntecedentes.getCell("B83").value = "Fecha en que se identificó la pérdida auditiva:";
  Object.assign(sheetAntecedentes.getCell("B83"), estiloTitulo);
  sheetAntecedentes.getCell("C83").value = formatearFechaSiEsValida(
    detalleSolicitud.fechaPerdidaAuditiva
  );

  sheetAntecedentes.getCell("E83").value = "Tiempo de inicio (meses):";
  Object.assign(sheetAntecedentes.getCell("E83"), estiloTitulo);
  sheetAntecedentes.getCell("F83").value =
    detalleSolicitud?.tiempoInicioPerdidaAud?.toString() ?? "";

  sheetAntecedentes.getCell("B84").value =
    "Centro, Institución o Profesional que lo diagnosticaron:";
  Object.assign(sheetAntecedentes.getCell("B84"), estiloTitulo);
  sheetAntecedentes.getCell("C84").value = detalleSolicitud.profQueDiagnostico;

  sheetAntecedentes.getCell("B85").value = "¿Cuál fue la causa de la pérdida auditiva?:";
  Object.assign(sheetAntecedentes.getCell("B85"), estiloTitulo);
  sheetAntecedentes.getCell("C85").value = detalleSolicitud.causaPerdidaAuditiva;

  const tipoPerdida = _.find(catalogos.tiposPerdidaAuditiva, {
    idTipoPerdidaAuditiva: detalleSolicitud.idTipoPerdidaAuditiva,
  });
  sheetAntecedentes.getCell("E85").value = "Tipo de pérdida:";
  Object.assign(sheetAntecedentes.getCell("E85"), estiloTitulo);
  sheetAntecedentes.getCell("F85").value = tipoPerdida.tipoPerdidaAuditiva;

  sheetAntecedentes.getCell("B86").value = "Grado de Hipoacusia:";
  Object.assign(sheetAntecedentes.getCell("B86"), estiloTitulo);
  sheetAntecedentes.getCell("C86").value = detalleSolicitud.gradoHipoacusia;

  sheetAntecedentes.getCell("B87").value = "¿Tiene estudios de audición?:";
  Object.assign(sheetAntecedentes.getCell("B87"), estiloTitulo);
  sheetAntecedentes.getCell("C87").value =
    detalleSolicitud.tieneEstudiosAudicion == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E87").value = "¿Cuáles?:";
  Object.assign(sheetAntecedentes.getCell("E87"), estiloTitulo);
  sheetAntecedentes.getCell("F87").value = detalleSolicitud.estudiosAudicion;

  sheetAntecedentes.getCell("B88").value = "¿Cuál fue el diagnóstico?:";
  Object.assign(sheetAntecedentes.getCell("B88"), estiloTitulo);
  sheetAntecedentes.getCell("C88").value = detalleSolicitud.diagnosticoAudicion;

  sheetAntecedentes.getCell("B89").value = "¿Utiliza auxiliares auditivos?:";
  Object.assign(sheetAntecedentes.getCell("B89"), estiloTitulo);
  sheetAntecedentes.getCell("C89").value = detalleSolicitud.utilizaAuxAuditivos == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E89").value = "Marca y Modelo:";
  Object.assign(sheetAntecedentes.getCell("E89"), estiloTitulo);
  sheetAntecedentes.getCell("F89").value = detalleSolicitud.marcaAuxAuditivos;

  sheetAntecedentes.getCell("B90").value = "Fecha de la 1a adaptación de auxiliares auditivos:";
  Object.assign(sheetAntecedentes.getCell("B90"), estiloTitulo);
  sheetAntecedentes.getCell("C90").value =
    formatearFechaSiEsValida(detalleSolicitud.fechaAdaptacionAuxiliaresAud) != "1900/01/01"
      ? formatearFechaSiEsValida(detalleSolicitud.fechaAdaptacionAuxiliaresAud)
      : "";

  sheetAntecedentes.getCell("B91").value = "¿Le han ajustado auxiliares auditivos?:";
  Object.assign(sheetAntecedentes.getCell("B91"), estiloTitulo);
  sheetAntecedentes.getCell("C91").value =
    detalleSolicitud.haAjustadoAuxAuditivos == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E91").value = "¿Cuándo?:";
  Object.assign(sheetAntecedentes.getCell("E91"), estiloTitulo);
  sheetAntecedentes.getCell("F91").value =
    formatearFechaSiEsValida(detalleSolicitud.fechaAjusteAuxAuditivos) != "1900/01/01"
      ? formatearFechaSiEsValida(detalleSolicitud.fechaAjusteAuxAuditivos)
      : "";

  sheetAntecedentes.getCell("B92").value = "Nombre del Audiólogo que los ajustó:";
  Object.assign(sheetAntecedentes.getCell("B92"), estiloTitulo);
  sheetAntecedentes.getCell("C92").value = detalleSolicitud.audiologoAjuste;

  sheetAntecedentes.getCell("B93").value = "¿Ha recibido Terapia Auditiva-Verbal?:";
  Object.assign(sheetAntecedentes.getCell("B93"), estiloTitulo);
  sheetAntecedentes.getCell("C93").value =
    detalleSolicitud.haRecibidoTerapiaAudVerbal == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E93").value = "¿Con quién?:";
  Object.assign(sheetAntecedentes.getCell("E93"), estiloTitulo);
  sheetAntecedentes.getCell("F93").value = detalleSolicitud.terapiaAudVerbalQuien;

  sheetAntecedentes.getCell("B94").value = "Progresos obtenidos:";
  Object.assign(sheetAntecedentes.getCell("B94"), estiloTitulo);
  sheetAntecedentes.getCell("C94").value = detalleSolicitud.progresosObtenidos;

  sheetAntecedentes.getCell("B95").value = "Describa su lenguaje actualmente:";
  Object.assign(sheetAntecedentes.getCell("B95"), estiloTitulo);
  sheetAntecedentes.getCell("C95").value = detalleSolicitud.lenguajeActual;

  sheetAntecedentes.getCell("B96").value = "¿Qué escucha y entiende actualmente?:";
  Object.assign(sheetAntecedentes.getCell("B96"), estiloTitulo);
  sheetAntecedentes.getCell("C96").value = detalleSolicitud.escuchaActualmente;

  sheetAntecedentes.getCell("B97").value = "¿Ha sido evaluado de la vista?:";
  Object.assign(sheetAntecedentes.getCell("B97"), estiloTitulo);
  sheetAntecedentes.getCell("C97").value = detalleSolicitud.tieneEvaluacionVista == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B98").value = "¿Algún retraso en el desarrollo?:";
  Object.assign(sheetAntecedentes.getCell("B98"), estiloTitulo);
  sheetAntecedentes.getCell("C98").value =
    detalleSolicitud.tieneRetrasoDesarrollo == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E98").value = "¿Cuál?:";
  Object.assign(sheetAntecedentes.getCell("E98"), estiloTitulo);
  sheetAntecedentes.getCell("F98").value = detalleSolicitud.cualRetraso;

  sheetAntecedentes.getCell("B100").value = "DESARROLLO MOTOR";
  sheetAntecedentes.getCell("B100").font = { bold: true, size: 12 };

  sheetAntecedentes.getCell("B102").value = "Edad a la que sostuvo su cabeza (meses):";
  Object.assign(sheetAntecedentes.getCell("B102"), estiloTitulo);
  sheetAntecedentes.getCell("C102").value = detalleSolicitud?.edadSostuvoCabeza?.toString() ?? "";

  sheetAntecedentes.getCell("E102").value = "Edad a la que gateó:";
  Object.assign(sheetAntecedentes.getCell("E102"), estiloTitulo);
  sheetAntecedentes.getCell("F102").value = detalleSolicitud?.edadGateo?.toString() ?? "";

  sheetAntecedentes.getCell("B103").value = "Edad en la que se paró:";
  Object.assign(sheetAntecedentes.getCell("B103"), estiloTitulo);
  sheetAntecedentes.getCell("C103").value = detalleSolicitud?.edadParo?.toString() ?? "";

  sheetAntecedentes.getCell("B104").value = "Edad a la que se sentó (meses):";
  Object.assign(sheetAntecedentes.getCell("B104"), estiloTitulo);
  sheetAntecedentes.getCell("C104").value = detalleSolicitud?.edadSento?.toString() ?? "";

  sheetAntecedentes.getCell("E104").value = "Edad a la que caminó:";
  Object.assign(sheetAntecedentes.getCell("E104"), estiloTitulo);
  sheetAntecedentes.getCell("F104").value = detalleSolicitud?.edadCamino?.toString() ?? "";

  sheetAntecedentes.getCell("B105").value = "Edad en la que comenzó rodamiento o giros:";
  Object.assign(sheetAntecedentes.getCell("B105"), estiloTitulo);
  sheetAntecedentes.getCell("C105").value = detalleSolicitud?.edadGiros?.toString() ?? "";

  sheetAntecedentes.getCell("B106").value = "Edad a la que comió por si solo (meses):";
  Object.assign(sheetAntecedentes.getCell("B106"), estiloTitulo);
  sheetAntecedentes.getCell("C106").value = detalleSolicitud?.edadComio?.toString() ?? "";

  sheetAntecedentes.getCell("E106").value =
    "Edad a la que comenzó a ir al baño (control de esfínteres):";
  Object.assign(sheetAntecedentes.getCell("E106"), estiloTitulo);
  sheetAntecedentes.getCell("F106").value = detalleSolicitud?.edadBano?.toString() ?? "";

  sheetAntecedentes.getCell("B107").value = "Edad en la que comenzó con sonrisa social:";
  Object.assign(sheetAntecedentes.getCell("B107"), estiloTitulo);
  sheetAntecedentes.getCell("C107").value = detalleSolicitud?.edadSonrisaSocial?.toString() ?? "";

  sheetAntecedentes.getCell("E107").value = "Edad en la que comenzó a balbuear:";
  Object.assign(sheetAntecedentes.getCell("E107"), estiloTitulo);
  sheetAntecedentes.getCell("F107").value = detalleSolicitud?.edadBalbuceo?.toString() ?? "";

  sheetAntecedentes.getCell("B108").value =
    "Edad de las primeras palabras (leche, agua, mamá, papá) en caso de que lo haya hecho:";
  Object.assign(sheetAntecedentes.getCell("B108"), estiloTitulo);
  sheetAntecedentes.getCell("C108").value =
    detalleSolicitud?.edadPrimerasPalabras?.toString() ?? "";

  sheetAntecedentes.getCell("E108").value =
    "Edad en la que nombra objetos simples (perro, carro, árbol), en caso de que lo haya hecho:";
  Object.assign(sheetAntecedentes.getCell("E108"), estiloTitulo);
  sheetAntecedentes.getCell("F108").value = detalleSolicitud?.edadObjetosSimples?.toString() ?? "";

  sheetAntecedentes.getCell("B109").value = "¿Tiene contacto visual?:";
  Object.assign(sheetAntecedentes.getCell("B109"), estiloTitulo);
  sheetAntecedentes.getCell("C109").value = detalleSolicitud.contactoVisual == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E109").value = "¿Usa dedo para señalar?:";
  Object.assign(sheetAntecedentes.getCell("E109"), estiloTitulo);
  sheetAntecedentes.getCell("F109").value = detalleSolicitud.dedoApuntar == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("B110").value = "Comunicación que buscas para tu hijo:";
  Object.assign(sheetAntecedentes.getCell("B110"), estiloTitulo);
  sheetAntecedentes.getCell("C110").value =
    detalleSolicitud.contactoVisual == 1 ? "Oral" : "Lenguje o Señas";

  sheetAntecedentes.getCell("B112").value = "INFORMACIÓN ADICIONAL";
  sheetAntecedentes.getCell("B112").font = { bold: true, size: 12 };

  sheetAntecedentes.getCell("B114").value =
    "¿Ha aplicado a algún otro programa de implantes cocleares?";
  Object.assign(sheetAntecedentes.getCell("B114"), estiloTitulo);
  sheetAntecedentes.getCell("C114").value =
    detalleSolicitud.aplicadoOtroPrograma == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E114").value = "¿A cuál?";
  Object.assign(sheetAntecedentes.getCell("E114"), estiloTitulo);
  sheetAntecedentes.getCell("F114").value = detalleSolicitud.aplicadoOtroProgramaCual;

  sheetAntecedentes.getCell("B115").value =
    "¿Lo han rechazado de algún otro programa de implante coclear?";
  Object.assign(sheetAntecedentes.getCell("B115"), estiloTitulo);
  sheetAntecedentes.getCell("C115").value = detalleSolicitud.rechazadoPrograma == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E115").value = "¿De cuál?";
  Object.assign(sheetAntecedentes.getCell("E115"), estiloTitulo);
  sheetAntecedentes.getCell("F115").value = detalleSolicitud.rechazadoProgramaCual;

  sheetAntecedentes.getCell("B116").value = "¿Ha sido evaluado por algún otro especialista?";
  Object.assign(sheetAntecedentes.getCell("B116"), estiloTitulo);
  sheetAntecedentes.getCell("C116").value =
    detalleSolicitud.evalOtroEspecialista == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E116").value = "¿Cuál? ¿Motivo?";
  Object.assign(sheetAntecedentes.getCell("E116"), estiloTitulo);
  sheetAntecedentes.getCell("F116").value = detalleSolicitud.evalOtroEspecialistaCual;

  sheetAntecedentes.getCell("B117").value = "¿Ha sido evaluado por odontología?";
  Object.assign(sheetAntecedentes.getCell("B117"), estiloTitulo);
  sheetAntecedentes.getCell("C117").value = detalleSolicitud.evaluadoOdontologia == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E117").value = "Nombre del doctor";
  Object.assign(sheetAntecedentes.getCell("E117"), estiloTitulo);
  sheetAntecedentes.getCell("F117").value = detalleSolicitud.evaluadoOdontologiaDr;

  sheetAntecedentes.getCell("B118").value = "¿Cuenta con servicio de internet en casa?";
  Object.assign(sheetAntecedentes.getCell("B118"), estiloTitulo);
  sheetAntecedentes.getCell("C118").value = detalleSolicitud.servicioInternet == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E118").value = "¿Cuál?";
  Object.assign(sheetAntecedentes.getCell("E118"), estiloTitulo);
  sheetAntecedentes.getCell("F118").value = detalleSolicitud.servicioInternetCual;

  sheetAntecedentes.getCell("B119").value = "¿Cuenta con computadora, tablet o celular?";
  Object.assign(sheetAntecedentes.getCell("B119"), estiloTitulo);
  sheetAntecedentes.getCell("C119").value = detalleSolicitud.computadora == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E119").value = "¿Cuál?";
  Object.assign(sheetAntecedentes.getCell("E119"), estiloTitulo);
  sheetAntecedentes.getCell("F119").value = detalleSolicitud.computadoraCual;

  sheetAntecedentes.getCell("B120").value =
    "¿Han utilizado alguna plataforma para video llamadas por internet?";
  Object.assign(sheetAntecedentes.getCell("B120"), estiloTitulo);
  sheetAntecedentes.getCell("C120").value = detalleSolicitud.plataformaVideo == 1 ? "Sí" : "No";

  sheetAntecedentes.getCell("E120").value = "¿Cuál?";
  Object.assign(sheetAntecedentes.getCell("E120"), estiloTitulo);
  sheetAntecedentes.getCell("F120").value = detalleSolicitud.plataformaVideoCual;

  const obtenerColor = (valor) => {
    switch (valor) {
      case 0:
        return valor === 0 ? "FFF58020" : ""; // En revisión
      case 1:
        return valor === 1 ? "FF388E3C" : ""; // Validada
      case 2:
        return valor === 2 ? "FFD32F2F" : ""; // Rechazada
      default:
        return "";
    }
  };

  //DOC ADMINISTRATIVA
  const sheetDocAdmin = workbook.addWorksheet("Doc. Administrativa");
  sheetDocAdmin.getColumn("B").width = 60;
  sheetDocAdmin.getColumn("C").width = 18;
  sheetDocAdmin.getColumn("D").width = 15;
  sheetDocAdmin.getColumn("E").width = 15;
  sheetDocAdmin.getColumn("F").width = 15;
  sheetDocAdmin.getColumn("G").width = 20;

  sheetDocAdmin.getCell("B2").value = "DOC. ADMINISTRATIVA";
  sheetDocAdmin.getCell("B2").font = { bold: true, size: 12 };

  sheetDocAdmin.getCell("D3").value = "En revisión";
  Object.assign(sheetDocAdmin.getCell("D3"), estiloTitulo);
  sheetDocAdmin.getCell("E3").value = "Validada";
  Object.assign(sheetDocAdmin.getCell("E3"), estiloTitulo);
  sheetDocAdmin.getCell("F3").value = "Rechazada";
  Object.assign(sheetDocAdmin.getCell("F3"), estiloTitulo);
  sheetDocAdmin.getCell("G3").value = "Estatus cambiado por";
  Object.assign(sheetDocAdmin.getCell("G3"), estiloTitulo);

  documentacionAdministrativa.forEach((doc, index) => {
    const row = index + 4; // Comienza en la fila 4

    sheetDocAdmin.getCell(`B${row}`).value = doc.label;
    Object.assign(sheetDocAdmin.getCell(`B${row}`), estiloTitulo);
    if (doc.archivo) {
      sheetDocAdmin.getCell(`C${row}`).value = {
        text: "Decargar",
        hyperlink: getApiBase().concat("/").concat(doc.archivo),
      };
      sheetDocAdmin.getCell(`G${row}`).value = doc.validadopor;

      switch (doc.validado) {
        case 0:
          sheetDocAdmin.getCell(`D${row}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: obtenerColor(doc.validado) },
          };
          break;
        case 1:
          sheetDocAdmin.getCell(`E${row}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: obtenerColor(doc.validado) },
          };
          break;
        case 2:
          sheetDocAdmin.getCell(`F${row}`).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: obtenerColor(doc.validado) },
          };
          break;
        default:
          break;
      }
    } else {
      sheetDocAdmin.getCell(`C${row}`).value = "-";
    }
  });

  sheetDocAdmin.getCell("B20").value = "Observaciones:";
  Object.assign(sheetDocAdmin.getCell("B20"), estiloTitulo);
  sheetDocAdmin.getCell("C20").value = detalleSolicitud?.observacionesDocAdmva;

  //DOC CLÍNICA
  const sheetDocClinic = workbook.addWorksheet("Doc. Clínica");
  sheetDocClinic.getColumn("B").width = 60;
  sheetDocClinic.getColumn("C").width = 18;
  sheetDocClinic.getColumn("D").width = 15;
  sheetDocClinic.getColumn("E").width = 15;
  sheetDocClinic.getColumn("F").width = 15;
  sheetDocClinic.getColumn("G").width = 20;

  sheetDocClinic.getCell("B2").value = "DOC. CLÍNICA";
  sheetDocClinic.getCell("B2").font = { bold: true, size: 12 };

  sheetDocClinic.getCell("D3").value = "En revisión";
  Object.assign(sheetDocClinic.getCell("D3"), estiloTitulo);
  sheetDocClinic.getCell("E3").value = "Validada";
  Object.assign(sheetDocClinic.getCell("E3"), estiloTitulo);
  sheetDocClinic.getCell("F3").value = "Rechazada";
  Object.assign(sheetDocClinic.getCell("F3"), estiloTitulo);
  sheetDocClinic.getCell("G3").value = "Estatus cambiado por";
  Object.assign(sheetDocClinic.getCell("G3"), estiloTitulo);

  let row1 = 3;
  documentacionAdministrativa.forEach((doc, index) => {
    if (doc.label == "Cartilla de Vacunación" || doc.label == "Cuestionario de Expectativas") {
      row1++;

      sheetDocClinic.getCell(`B${row1}`).value = doc.label;
      Object.assign(sheetDocClinic.getCell(`B${row1}`), estiloTitulo);
      if (doc.archivo) {
        sheetDocClinic.getCell(`C${row1}`).value = {
          text: "Decargar",
          hyperlink: getApiBase().concat("/").concat(doc.archivo),
        };
        sheetDocClinic.getCell(`G${row1}`).value = doc.validadopor;

        switch (doc.validado) {
          case 0:
            sheetDocClinic.getCell(`D${row1}`).fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: obtenerColor(doc.validado) },
            };
            break;
          case 1:
            sheetDocClinic.getCell(`E${row1}`).fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: obtenerColor(doc.validado) },
            };
            break;
          case 2:
            sheetDocClinic.getCell(`F${row1}`).fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: obtenerColor(doc.validado) },
            };
            break;
          default:
            break;
        }
      } else {
        sheetDocClinic.getCell(`C${row1}`).value = "-";
      }
    }
  });

  let row2 = 5;
  documentos.documentacionClinica.forEach((doc, index) => {
    row2++;

    sheetDocClinic.getCell(`B${row2}`).value = doc.titulo;
    Object.assign(sheetDocClinic.getCell(`B${row2}`), estiloTitulo);
    sheetDocClinic.getCell(`C${row2}`).value = {
      text: "Decargar",
      hyperlink: getApiBase().concat("/").concat(doc.rutaDescarga),
    };
    sheetDocClinic.getCell(`G${row2}`).value = doc.validadopor;

    switch (doc.estado) {
      case 0:
        sheetDocClinic.getCell(`D${row2}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 1:
        sheetDocClinic.getCell(`E${row2}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 2:
        sheetDocClinic.getCell(`F${row2}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      default:
        break;
    }
  });

  sheetDocClinic.getCell(`B${row2 + 2}`).value = "Observaciones Otorrinolaringología:";
  Object.assign(sheetDocClinic.getCell(`B${row2 + 2}`), estiloTitulo);
  sheetDocClinic.getCell(`C${row2 + 2}`).value = detalleSolicitud?.observacionesOtorrino;
  sheetDocClinic.getCell(`B${row2 + 3}`).value = "Observaciones Audiología:";
  Object.assign(sheetDocClinic.getCell(`B${row2 + 3}`), estiloTitulo);
  sheetDocClinic.getCell(`C${row2 + 3}`).value = detalleSolicitud?.observacionesAudiologo;

  //EST SOCIECONÓMICO
  const sheetEstudiosSE = workbook.addWorksheet("Est. Socioeconómico");
  sheetEstudiosSE.getColumn("B").width = 60;
  sheetEstudiosSE.getColumn("C").width = 18;
  sheetEstudiosSE.getColumn("D").width = 15;
  sheetEstudiosSE.getColumn("E").width = 15;
  sheetEstudiosSE.getColumn("F").width = 15;
  sheetEstudiosSE.getColumn("G").width = 20;

  sheetEstudiosSE.getCell("B2").value = "EST. SOCIOECONÓMICO";
  sheetEstudiosSE.getCell("B2").font = { bold: true, size: 12 };

  sheetEstudiosSE.getCell("D3").value = "En revisión";
  Object.assign(sheetEstudiosSE.getCell("D3"), estiloTitulo);
  sheetEstudiosSE.getCell("E3").value = "Validada";
  Object.assign(sheetEstudiosSE.getCell("E3"), estiloTitulo);
  sheetEstudiosSE.getCell("F3").value = "Rechazada";
  Object.assign(sheetEstudiosSE.getCell("F3"), estiloTitulo);
  sheetEstudiosSE.getCell("G3").value = "Estatus cambiado por";
  Object.assign(sheetEstudiosSE.getCell("G3"), estiloTitulo);

  documentos.estudiosSE.forEach((doc, index) => {
    const row = index + 4;

    sheetEstudiosSE.getCell(`B${row}`).value = doc.estudioSE;
    Object.assign(sheetEstudiosSE.getCell(`B${row}`), estiloTitulo);
    sheetEstudiosSE.getCell(`C${row}`).value = {
      text: "Decargar",
      hyperlink: getApiBase().concat("/").concat(doc.rutaDescarga),
    };
    sheetEstudiosSE.getCell(`G${row}`).value = doc.validadopor;

    switch (doc.estado) {
      case 0:
        sheetEstudiosSE.getCell(`D${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 1:
        sheetEstudiosSE.getCell(`E${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 2:
        sheetEstudiosSE.getCell(`F${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      default:
        break;
    }
  });

  //GESTIÓN DE CITAS
  const sheetCitas = workbook.addWorksheet("Gestión de Citas");
  sheetCitas.getColumn("B").width = 40;
  sheetCitas.getColumn("C").width = 18;
  sheetCitas.getColumn("D").width = 60;
  sheetCitas.getColumn("E").width = 40;
  sheetCitas.getColumn("F").width = 35;
  sheetCitas.getColumn("G").width = 20;

  sheetCitas.getCell("B2").value = "GESTIÓN DE CITAS";
  sheetCitas.getCell("B2").font = { bold: true, size: 12 };

  sheetCitas.getCell("B4").value = "CITAS PRÓXIMAS";
  sheetCitas.getCell("B4").font = { size: 12 };

  sheetCitas.getCell("B5").value = "Fecha";
  Object.assign(sheetCitas.getCell("B5"), estiloTitulo);
  sheetCitas.getCell("C5").value = "Hora";
  Object.assign(sheetCitas.getCell("C5"), estiloTitulo);
  sheetCitas.getCell("D5").value = "Estudio";
  Object.assign(sheetCitas.getCell("D5"), estiloTitulo);
  sheetCitas.getCell("E5").value = "Lugar";
  Object.assign(sheetCitas.getCell("E5"), estiloTitulo);
  sheetCitas.getCell("F5").value = "Médico";
  Object.assign(sheetCitas.getCell("F5"), estiloTitulo);
  sheetCitas.getCell("G5").value = "Observaciones";
  Object.assign(sheetCitas.getCell("G5"), estiloTitulo);

  let row4 = 5;
  citasProximas.forEach((cita, index) => {
    row4++;

    sheetCitas.getCell(`B${row4}`).value = moment(cita.fechaCita).format(
      "dddd D [de] MMMM [de] YYYY"
    );

    sheetCitas.getCell(`C${row4}`).value = `${String(cita.horaCita).padStart(2, "0")}:${String(
      cita.minutoCita
    ).padStart(2, "0")} Hrs`;

    sheetCitas.getCell(`D${row4}`).value =
      _.find(catalogos.estudios, { idEstudio: cita.idEstudio })?.descripcion || "";

    sheetCitas.getCell(`E${row4}`).value = cita.hospital;

    sheetCitas.getCell(`F${row4}`).value =
      cita.idMedico == 0 ? "No Asignado" : `${cita.nombreMedico} ${cita.apellidoPaternoMedico}`;

    sheetCitas.getCell(`G${row4}`).value = cita.observaciones;
  });

  sheetCitas.getCell(`B${row4 + 3}`).value = "CITAS ANTERIORES";
  sheetCitas.getCell(`B${row4 + 3}`).font = { size: 12 };

  let row5 = row4 + 4;

  sheetCitas.getCell(`B${row5}`).value = "Fecha";
  Object.assign(sheetCitas.getCell(`B${row5}`), estiloTitulo);
  sheetCitas.getCell(`C${row5}`).value = "Hora";
  Object.assign(sheetCitas.getCell(`C${row5}`), estiloTitulo);
  sheetCitas.getCell(`D${row5}`).value = "Estudio";
  Object.assign(sheetCitas.getCell(`D${row5}`), estiloTitulo);
  sheetCitas.getCell(`E${row5}`).value = "Lugar";
  Object.assign(sheetCitas.getCell(`E${row5}`), estiloTitulo);
  sheetCitas.getCell(`F${row5}`).value = "Médico";
  Object.assign(sheetCitas.getCell(`F${row5}`), estiloTitulo);
  sheetCitas.getCell(`G${row5}`).value = "Observaciones";
  Object.assign(sheetCitas.getCell(`G${row5}`), estiloTitulo);

  citasAnteriores.forEach((cita, index) => {
    row5++;

    sheetCitas.getCell(`B${row5}`).value = moment(cita.fechaCita).format(
      "dddd D [de] MMMM [de] YYYY"
    );

    sheetCitas.getCell(`C${row5}`).value = `${String(cita.horaCita).padStart(2, "0")}:${String(
      cita.minutoCita
    ).padStart(2, "0")} Hrs`;

    sheetCitas.getCell(`D${row5}`).value =
      _.find(catalogos.estudios, { idEstudio: cita.idEstudio })?.descripcion || "";

    sheetCitas.getCell(`E${row5}`).value = cita.hospital;

    sheetCitas.getCell(`F${row5}`).value =
      cita.idMedico == 0 ? "No Asignado" : `${cita.nombreMedico} ${cita.apellidoPaternoMedico}`;

    sheetCitas.getCell(`G${row5}`).value = cita.observaciones;
  });

  //DOC REUNIÓN NACIONAL
  const sheetReunionN = workbook.addWorksheet("Reunión Nacional");
  sheetReunionN.getColumn("B").width = 60;
  sheetReunionN.getColumn("C").width = 18;
  sheetReunionN.getColumn("D").width = 15;
  sheetReunionN.getColumn("E").width = 15;
  sheetReunionN.getColumn("F").width = 15;
  sheetReunionN.getColumn("G").width = 20;

  sheetReunionN.getCell("B2").value = "REUNIÓN NACIONAL";
  sheetReunionN.getCell("B2").font = { bold: true, size: 12 };

  sheetReunionN.getCell("D3").value = "En revisión";
  Object.assign(sheetReunionN.getCell("D3"), estiloTitulo);
  sheetReunionN.getCell("E3").value = "Validada";
  Object.assign(sheetReunionN.getCell("E3"), estiloTitulo);
  sheetReunionN.getCell("F3").value = "Rechazada";
  Object.assign(sheetReunionN.getCell("F3"), estiloTitulo);
  sheetReunionN.getCell("G3").value = "Estatus cambiado por";
  Object.assign(sheetReunionN.getCell("G3"), estiloTitulo);

  documentos.docsReunionNacional.forEach((doc, index) => {
    const row = index + 4;

    sheetReunionN.getCell(`B${row}`).value = doc.tituloDocumento;
    Object.assign(sheetReunionN.getCell(`B${row}`), estiloTitulo);
    sheetReunionN.getCell(`C${row}`).value = {
      text: "Decargar",
      hyperlink: getApiBase().concat("/").concat(doc.rutaDescarga),
    };
    sheetReunionN.getCell(`G${row}`).value = doc.validadopor;

    switch (doc.estado) {
      case 0:
        sheetReunionN.getCell(`D${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 1:
        sheetReunionN.getCell(`E${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 2:
        sheetReunionN.getCell(`F${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      default:
        break;
    }
  });

  //DOC REUNIÓN BOSTÓN
  const sheetReunionB = workbook.addWorksheet("Reunión Boston");
  sheetReunionB.getColumn("B").width = 60;
  sheetReunionB.getColumn("C").width = 18;
  sheetReunionB.getColumn("D").width = 15;
  sheetReunionB.getColumn("E").width = 15;
  sheetReunionB.getColumn("F").width = 15;
  sheetReunionB.getColumn("G").width = 20;

  sheetReunionB.getCell("B2").value = "REUNIÓN BOSTON";
  sheetReunionB.getCell("B2").font = { bold: true, size: 12 };

  sheetReunionB.getCell("D3").value = "En revisión";
  Object.assign(sheetReunionB.getCell("D3"), estiloTitulo);
  sheetReunionB.getCell("E3").value = "Validada";
  Object.assign(sheetReunionB.getCell("E3"), estiloTitulo);
  sheetReunionB.getCell("F3").value = "Rechazada";
  Object.assign(sheetReunionB.getCell("F3"), estiloTitulo);
  sheetReunionB.getCell("G3").value = "Estatus cambiado por";
  Object.assign(sheetReunionB.getCell("G3"), estiloTitulo);

  documentos.docsReunionBoston.forEach((doc, index) => {
    const row = index + 4;

    sheetReunionB.getCell(`B${row}`).value = doc.tituloDocumento;
    Object.assign(sheetReunionB.getCell(`B${row}`), estiloTitulo);
    sheetReunionB.getCell(`C${row}`).value = {
      text: "Decargar",
      hyperlink: getApiBase().concat("/").concat(doc.rutaDescarga),
    };
    sheetReunionB.getCell(`G${row}`).value = doc.validadopor;

    switch (doc.estado) {
      case 0:
        sheetReunionB.getCell(`D${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 1:
        sheetReunionB.getCell(`E${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      case 2:
        sheetReunionB.getCell(`F${row}`).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: obtenerColor(doc.estado) },
        };
        break;
      default:
        break;
    }
  });

  //GALERIA
  const sheetGaleria = workbook.addWorksheet("Galeria");
  sheetGaleria.getColumn("B").width = 25;
  sheetGaleria.getColumn("C").width = 20;
  sheetGaleria.getColumn("D").width = 30;
  sheetGaleria.getColumn("E").width = 15;

  sheetGaleria.getCell("B2").value = "GALERIA";
  sheetGaleria.getCell("B2").font = { bold: true, size: 12 };

  sheetGaleria.getCell("B4").value = "Titulo";
  Object.assign(sheetGaleria.getCell("B4"), estiloTitulo);
  sheetGaleria.getCell("C4").value = "Fecha de carga";
  Object.assign(sheetGaleria.getCell("C4"), estiloTitulo);
  sheetGaleria.getCell("D4").value = "Descripción";
  Object.assign(sheetGaleria.getCell("D4"), estiloTitulo);

  let row6 = 4;
  detalleSolicitud.galeria.forEach((archivo, index) => {
    row6++;

    sheetGaleria.getCell(`B${row6}`).value = archivo.galeriaNombre;

    sheetGaleria.getCell(`C${row6}`).value = moment(archivo.fechaFoto).format("DD/MM/YY");

    sheetGaleria.getCell(`D${row6}`).value = archivo.descripcion;

    sheetGaleria.getCell(`E${row6}`).value = {
      text: "Decargar",
      hyperlink: getApiBase().concat("/").concat(archivo.rutaDescargar),
    };
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const nombreArchivo = `${esSolicitud ? "Solicitud" : "Expediente"}_${
    detalleSolicitud.aPaternoCandidato
  }_${detalleSolicitud.aMaternoCandidato}_${detalleSolicitud.nombreCandidato}.xlsx`;
  saveAs(blob, nombreArchivo);
};
